import {gunaldiStyles} from "../SharedComponents/GunaldiDesignStyles";

export const planBgColor = ["white", "#F4FBF3", "#6FBB98", gunaldiStyles.blue, "black"]